const React = require("react");
const upperFirst = require("mn-utils/upperFirst");
const {DisplayStatusTrx} = require("../components/dumb/StatusDisplay");

const STATUSES_TRX_IDS = [
  'pending',
  'confirmation',
  'accepted',
  'cancelled',
  'expired',
  'blocked',
];

const STATUS_TRX_COLOR = {
  pending: 'cFFCC18',
  confirmation: 'cFF7F23',
  accepted: 'c2CE889',
  expired: 'c73757A',
  cancelled: 'cFF481F',
  blocked: 'cFF481F',
  refunded: 'cFF481F'
}

const name = 'lifeflow';

const STATUSES_FILTER_SELECT = {
  name,
  placeholder: 'Status',
  className: 'wAuto (wmin105|wFitContent)>.MuiSelect-root',
  list: [
    {id: 'all', name: 'All statuses'},
    ...STATUSES_TRX_IDS.map((id) => ({
      id,
      name: id.split('_').map((el) => upperFirst(el)).join(' ')
    }))
  ]
};

const STATUSES_FILTER_TABLE_HEAD = {
  name,
  list: ['all', ...STATUSES_TRX_IDS].map((id) => ({
    id,
    nameHeadDisplay: id.split('_').map((el) => upperFirst(el)).join(' '),
    name: <DisplayStatusTrx status={id} />
  }))
};

module.exports = {
  STATUSES_TRX_IDS,
  STATUSES_FILTER_SELECT,
  STATUSES_FILTER_TABLE_HEAD,
};
